// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"33cfeda7","229":"6a5fc7b8","239":"e10265fa","389":"0b08073c","455":"9a88886b","507":"4fab5f08","553":"9978054d","977":"52b9389c"}[chunkId] + ".chunk.js";
};